import getTodoApiRequestUrl from './getToDoApiRequestUrl';
import { getFormattedCurrentDateForTodo } from './getCurrentDate';
import {
    makeGetRequest,
    makePostRequest,
    makePatchRequest,
    makeDeleteRequest,
} from 'owa-ows-gateway';

export async function getTaskFolders(): Promise<any> {
    const endPoint = await getTodoApiRequestUrl('/taskfolders');
    return makeGetRequest(endPoint);
}

interface QueryParamsProps {
    [key: string]: string | number;
}

export async function getTasksWithQueryParams(
    endPoint: string,
    queryParams?: QueryParamsProps
): Promise<any> {
    const filterParams = Object.entries(queryParams)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
    const url = `${endPoint}?${filterParams}`;

    return makeGetRequest(url);
}

export async function getTasksInTaskList(
    taskListId: string,
    queryParams: QueryParamsProps = {}
): Promise<any> {
    queryParams['$orderby'] = 'OrderDateTime/DateTime desc';
    const endPoint = await getTodoApiRequestUrl(`/taskfolders/${taskListId}/tasks/`);

    return getTasksWithQueryParams(endPoint, queryParams);
}

export async function getMyDayTasks(
    dateStr?: string,
    queryParams: QueryParamsProps = {}
): Promise<any> {
    const dateString = dateStr || getFormattedCurrentDateForTodo();
    queryParams['$orderby'] = 'OrderDateTime/DateTime desc';
    queryParams['date'] = dateString;
    const endPoint = await getTodoApiRequestUrl('/smartlists/myday/tasks/');

    return getTasksWithQueryParams(endPoint, queryParams);
}

export async function createTask(content: any): Promise<any> {
    const endPoint = await getTodoApiRequestUrl(`/taskfolders/${content.ParentFolderId}/tasks`);

    return makePostRequest(endPoint, content);
}

export async function updateTask(content: any): Promise<any> {
    const { Id, ParentFolderId, ...rest } = content;
    const endPoint = await getTodoApiRequestUrl(`/taskfolders/${ParentFolderId}/tasks/${Id}`);

    return makePatchRequest(endPoint, rest);
}

export async function deleteTask(content: any): Promise<any> {
    const endPoint = await getTodoApiRequestUrl(`/tasks/${content.Id}`);

    return makeDeleteRequest(endPoint);
}
